module.exports = __webpack_public_path__ + "static/media/chevron-down.aae10ca6.svg";